<template>
  <div class="App-buttons">
    <button-component
      :color="color"
      :value="text"
      :is-disabled="isDisabled"
      field-id="questionButton"
      log-action="abstain-modal"
      @click-abstain-modal="trackClick" />
  </div>
</template>

<script>
import ButtonComponent from '@/components/Button.vue';

export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Next Step'
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  components: {
    ButtonComponent
  },
  methods: {
    trackClick() {
      this.$emit('button-clicked');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Questions/QuestionsButton.vue